import React from "react";

const XIcon = props => (
  <svg width="1em" height="1em" viewBox="0 0 18 18" {...props}>
    <path
      fill="currentColor"
      d="M9.707 9L17.853.854a.5.5 0 0 0-.707-.707L9 8.293.854.146a.5.5 0 0 0-.707.707L8.293 9 .147 17.146a.5.5 0 0 0 .707.708L9 9.707l8.146 8.146a.5.5 0 1 0 .708-.706L9.707 9z"
    />
  </svg>
);

export default XIcon;
